import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import Router from 'next/router';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestDoctors({
  payload: { page = 0, limit = 20 },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.get('/admin/doctors', {
        params: {
          page,
          limit,
        },
      })
    );

    yield put(actions.saveDoctors({ data: { ...response.data, limit } }));
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestDoctor() {
  yield takeEvery(actions.requestDoctors, requestDoctors);
}

function* deleteDoctor({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/doctors/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      Router.back();
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherDeleteDoctor() {
  yield takeLatest(actions.deleteDoctor, deleteDoctor);
}
const doctorSagas = function* root() {
  yield all([fork(watcherRequestDoctor), fork(watcherDeleteDoctor)]);
};
export { doctorSagas };
